<template>
  <footer class="footer mt-auto">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-12 py-3">
          <p><img class="img-footer img-fluid" src="../assets/img/logo-mist.png" style=" max-width:10%; height:auto "></p>
        </div>
      </div>
    </div>
  </footer>

</template>

<script>
export default {
  name: "MyFooter"
}
</script>

<style scoped>

</style>